export const locale = {
  lang: 'pt',
  data: {
    'CHANGELOG': {
      'TITULO': 'Changelog',
      'SUBTITULO': 'Verifique as atualizações feitas na plataforma ao longo do tempo',
      'ULTIMA': 'Última atualização',
      'CATEGORIAS': {
        'Changed': 'Atualizações',
        'Fixed': 'Conserta',
        'Added': 'Melhorias'
      }
    },
    'KNOWLEDGE': {
      'LINK': 'Clique neste link se a plataforma não redirecionar você automaticamente'
    }
  }
};
